import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        lease: {},
        lease_document_url: '',
        leases: {data: [], current_page: 1, total: 0, per_page: 10},
        rendered_template: "",
        lease_document_uploaded: false,
        lease_document: null,
        lease_preview_status: "pending",
        loading: false,
        errors: {data: {errors: {}}},
        has_errors: false,
    },
    getters: {
        lease: state => state.lease,
        leases: state => state.leases,
        lease_document_url: state => state.lease_document_url,
        rendered_template: state => state.rendered_template,
        lease_preview_status: state => state.lease_preview_status,
        loading: state => state.loading,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        lease_document_uploaded: state => state.lease_document_uploaded,
        lease_document: state => state.lease_document,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val;
        },
        setLeases(state, data) {
            state.leases = data;
        },
        setLease(state, data) {
            state.lease = data;
        },
        setRenderedTemplate(state, html) {
            state.rendered_template = html;
        },
        setLeaseDocumentUploadStatus(state, status) {
            state.lease_document_uploaded = status;
        },
        setLeaseDocument(state, data) {
            state.lease_document = data;
        },
        setLeasePreviewStatus(state, status) {
            state.lease_preview_status = status;
        },
        setLeaseDocumentUrl(state, url) {
            state.lease_document_url = url;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        hasErrors(state, val) {
            state.has_errors = val;
        },
    },
    actions: {
        async getLeases({commit}, filters) {
            try {
                commit('setLoading', true);
                const response = await api.getLeases(filters);
                commit('setLeases', response);
            } catch (e) {
                ElMessage.error(e.response?.data?.message || "Failed to load Leases.");
            } finally {
                commit('setLoading', false);
            }
        },

        async getLease({commit}, id) {
            try {
                commit('setLoading', true);
                const response = await api.getLease(id);
                commit('setLease', response?.data);
            } catch (e) {
                ElMessage.error("Error loading lease.");
            } finally {
                commit('setLoading', false);
            }
        },

        async getLeasePreview({commit}, data) {
            try {
                commit('setLeasePreviewStatus', 'pending')
                commit('setLoading', true);
                const response = await api.getLeasePreview(data);
                commit('setLease', response.lease);
                commit('setRenderedTemplate', response.html);
                commit('setLeasePreviewStatus', 'success')
                commit('hasErrors', false)
            } catch (e) {
                commit('setErrors', e.response)
                commit('hasErrors', true)
                ElMessage.error("Error rendering preview!");
                commit('setLeasePreviewStatus', 'fail')
            } finally {
                commit('setLoading', false);
            }
        },
        async uploadLeaseDocument({commit}, data) {
            try {
                commit('setLeasePreviewStatus', 'pending')
                commit('setLoading', true);
                const response = await api.uploadLeaseDocument(data);
                commit('setLeaseDocument', response);
                commit('setLeaseDocumentUploadStatus', true)
            } catch (e) {
                ElMessage.error("Error uploading lease document!");
                commit('setLeaseDocumentUploadStatus', false)
            } finally {
                commit('setLoading', false);
            }
        },

        async generateDocumentUrl({commit}, data) {
            try {
                commit('setLoading', true);
                const response = await api.generateUrl(data);
                commit('setLeaseDocumentUrl', response?.url || '');
                commit('setLoading', false)
            } catch (e) {
                ElMessage.error("Error uploading lease document!");
            } finally {
                commit('setLoading', false);
            }
        },

        async createLease({dispatch, commit}, data) {
            try {
                await api.createLease(data);
                ElMessage.success('Lease created successfully!');
                dispatch('getLeases', {});
            } catch (e) {
                commit('hasErrors', true);
                commit('setErrors', e.response);
                ElMessage.error(e.response?.data?.message || "Error creating lease.");
            }
        },

        async editLease({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                const response = await api.editLease(data);
                commit('setLease', response?.data);
                dispatch('getLeases', {});
                return response?.data;
            } catch (e) {
                commit('hasErrors', true);
                commit('setErrors', e.response);
                ElMessage.error(e.response?.data?.message || "Error updating lease.");
                throw e;
            } finally {
                commit('setLoading', false);
            }
        },

        async signLease({commit, dispatch}, id) {
            try {
                const response = await api.signLease(id, {
                    signature_data: payload.signature_data,
                });
                ElMessage.success("Lease signed successfully!");
                dispatch('getLease', id);
            } catch (e) {
                ElMessage.error(e.response?.data?.message || "Error signing lease.");
            }
        },

        async deleteLease({dispatch}, data) {
            try {
                await api.deleteLease(data.lease_id);
                ElMessage.success("Lease deleted successfully.");
                dispatch('getLeases', {});
            } catch (e) {
                ElMessage.error("Error deleting lease.");
            }
        },

        async exportLeasesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportLeasesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Leases_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }
    }
}
